import { useState } from 'react'
import { Box, Tabs, Tab, Typography, Paper } from '@mui/material'
import { DataImport } from './DataImport'

const WORKBENCH_TABS = [
  { label: 'Import', key: 'import' },
  { label: 'Export', key: 'export' },
  { label: 'Monitor', key: 'monitor' },
]

function ComingSoon() {
  return (
    <Box sx={{ py: 8, textAlign: 'center' }}>
      <Typography variant="h6" color="text.secondary">Coming soon</Typography>
    </Box>
  )
}

export function DataWorkbench() {
  const [tab, setTab] = useState(0)

  return (
    <Box>
      <Paper variant="outlined" sx={{ mb: 2 }}>
        <Tabs value={tab} onChange={(_, v) => setTab(v)}>
          {WORKBENCH_TABS.map((t) => (
            <Tab key={t.key} label={t.label} />
          ))}
        </Tabs>
      </Paper>

      {tab === 0 && <DataImport />}
      {tab === 1 && <ComingSoon />}
      {tab === 2 && <ComingSoon />}
    </Box>
  )
}
